import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { storeToRefs } from 'pinia';
import { useInfo, useAnniversary } from '@/store';
import Comic from '@/components/anniversary/Comic.vue';
import Videos from '@/components/anniversary/Videos.vue';
import Schedule from '@/components/anniversary/Schedule.vue';
import IngameVideos from '@/components/anniversary/IngameVideos.vue';
import { useImgSrc } from '../components/anniversary/useAnniversaryImg';


export default /*#__PURE__*/_defineComponent({
  __name: 'Anniversary',
  setup(__props) {

const { isInitialized, comic } = storeToRefs(useAnniversary());
const { checkRoute } = useInfo();
const { getAnniversary } = useAnniversary();
const images = useImgSrc();
const imagesSrcList = Object.values(images).reduce((acc: string[], curr ) => {
  return [...acc, curr.pc, curr.mobile];
}, []);

(async () => {
  checkRoute('/anniversary', getAnniversary);
})();

return (_ctx: any,_cache: any) => {
  return (_unref(isInitialized))
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_unref(comic))
          ? (_openBlock(), _createBlock(Comic, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(Videos),
        _createVNode(Schedule),
        _createVNode(IngameVideos),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imagesSrcList), (item, index) => {
          return (_openBlock(), _createElementBlock("img", {
            style: {"display":"none"},
            key: index,
            src: item || undefined,
            alt: ""
          }, null, 8, _hoisted_1))
        }), 128))
      ], 64))
    : _createCommentVNode("", true)
}
}

})